module.exports = __webpack_public_path__ + "static/media/InternshipUpload_Template.562baf07.xlsx";